export interface PendingSelectDatesPrompt {
  vertical: App.SearchVertical
  propertyId: string
  propertyName: string
}

// Module-level, so on the server this is shared across concurrent requests — only safe because
// it's only ever written from a browser click handler, never during SSR. Keep it that way.
let pendingPrompt: PendingSelectDatesPrompt | undefined
const listeners = new Set<() => void>()

export function setPendingSelectDatesPrompt(prompt: PendingSelectDatesPrompt | undefined) {
  pendingPrompt = prompt
  listeners.forEach(listener => listener())
}

export function getPendingSelectDatesPromptSnapshot() {
  return pendingPrompt
}

export function subscribePendingSelectDatesPrompt(listener: () => void) {
  listeners.add(listener)
  return () => listeners.delete(listener)
}
